import {
  exists,
  SystemBatchMenuDetail,
  SystemBatchMenuDetailFromJSON
} from '@/api'

export interface SystemBatchMenu {
  id: number
  name: string
  menus: SystemBatchMenuDetail[]
  revision: number
}

export const defaultSystemBatchMenu = (): SystemBatchMenu => ({
  id: 0,
  name: '',
  menus: [],
  revision: 0
})

export function SystemBatchMenuFromJSON(json: any): SystemBatchMenu {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    menus: exists(json, 'menus')
      ? json.menus.map(SystemBatchMenuDetailFromJSON)
      : [],
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
